import { useQuery, UseQueryOptions } from 'react-query';

import { DataRoomFolder, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useDataRoomDocumentFoldersQuery(
	guid: Guid | undefined,
	options?: Omit<UseQueryOptions<DataRoomFolder[], unknown, DataRoomFolder[]>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.Folders(guid),
		() => AxiosUtils.getResponseData<DataRoomFolder[]>(api.get(CerebroApiEndpoints.DataRooms.Folders(guid))),
		options
	);
}
